<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CrftAddMain from "@/views/DevelopManagement/CrftManage/TabChild/CrftAddMain";
export default {
name: "CrftAdd",
  components: {
    childTab1: CrftAddMain,
  },
  data() {
    return {
      activeName: "first",
    }
  }
}
</script>

<style scoped>

</style>